import http from '@/utils/http' //引入axios
export const getAdModel = data => http.get('/file-center/api/ad/template', {
    params: data
}) //查找ad
export const editAdModel = data => http.put('/file-center/api/ad/template',
    data
) //修改ad
export const addAdModel = data => http.post('/file-center/api/ad/template',
    data
) //添加ad
export const deleteAdModel = data => http.delete('/file-center/api/ad/template', {
    params: data
}) //刪除ad
export const BindMachine = data => http.put('/file-center/api/ad/template/machine',
    data
) //模板绑定設備
export const Bindad = data => http.put('/file-center/api/ad/template/ad',
    data
) //模板绑定广告
export default {
    getAdModel,
    editAdModel,
    addAdModel,
    deleteAdModel,
    BindMachine,
    Bindad
}